import DailyCheckList from './DailyCheckList'
import NonComplianceItems from './NonComplianceItems'

const CentreManagerHomePage = () => {
    return (
        <div>
            <div>
                <h1>Centre Manager Home Page</h1>
            </div>
            <div>
                <DailyCheckList />
            </div>
            <div>
                <NonComplianceItems />
            </div>
        </div>
    )
}

export default CentreManagerHomePage;